import { render, staticRenderFns } from "./Hangyefenlei.vue?vue&type=template&id=253f8120&scoped=true&"
import script from "./Hangyefenlei.vue?vue&type=script&lang=js&"
export * from "./Hangyefenlei.vue?vue&type=script&lang=js&"
import style0 from "./Hangyefenlei.vue?vue&type=style&index=0&id=253f8120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253f8120",
  null
  
)

export default component.exports